var map = {
	"./blood_products_light.png": 20421,
	"./daily_routine_care_light.png": 89548,
	"./eye_care_light.png": 79943,
	"./feeding_tube_light.png": 70387,
	"./iv_fluids_light.png": 16953,
	"./nebulization_light.png": 9194,
	"./open_wound_care_light.png": 46234,
	"./ostomy_care_light.png": 20359,
	"./parental_nutrition_light.png": 6840,
	"./pressure_sore_care_light.png": 31549,
	"./pressure_sore_light.png": 80075,
	"./preventive_care_light.png": 85618,
	"./respiratory_care_light.png": 34834,
	"./specialist_consultation_light.png": 52263,
	"./urinary_catheter_care_light.png": 51927
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52535;